module.exports = __webpack_public_path__ + "img/M.acf1c8ee.png";